export interface ParsedPreselectFilters {
  fields: { key: string; values: string[] }[];
}

const decodeFormComponent = (raw: string): string => {
  try {
    return decodeURIComponent(raw.replace(/\+/g, " "));
  } catch {
    return raw;
  }
};

export const parsePreselectFilters = (raw: string): ParsedPreselectFilters => {
  const byKey = new Map<string, string[]>();

  if (typeof raw === "string" && raw.length > 0) {
    for (const pair of raw.split("&")) {
      const separatorIndex = pair.indexOf("=");
      if (separatorIndex <= 0) {
        continue;
      }

      const key = decodeFormComponent(pair.slice(0, separatorIndex)).trim();
      if (!key) {
        continue;
      }

      const values = pair
        .slice(separatorIndex + 1)
        .split(";")
        .map(value => decodeFormComponent(value).trim())
        .filter(Boolean);

      if (values.length === 0) {
        continue;
      }

      byKey.set(key, (byKey.get(key) ?? []).concat(values));
    }
  }

  return {
    fields: Array.from(byKey, ([key, values]) => ({ key, values })),
  };
};

export const extractPreselectFilterPairs = (
  search: string,
  systemKeys: Set<string>,
): string => {
  if (!search) {
    return "";
  }

  return search
    .replace(/^\?/, "")
    .split("&")
    .filter(pair => {
      const rawKey = pair.split("=")[0];
      if (!rawKey) {
        return false;
      }
      let key: string;
      try {
        key = decodeURIComponent(rawKey);
      } catch {
        key = rawKey;
      }
      return !systemKeys.has(key);
    })
    .join("&");
};
